import { COMPANY_TYPES } from '../../../utils/common'
import useCompanyHeader from '../../category/useCompanyHeader'
import { Element } from '../../html/element'
import { Notification } from '../../notification'
import { factSheetTypes } from './constants'
import { Content } from './Content'
import { Header } from './Header'
import './i18n'

export const FactSheet = ({ type }) => {
  const { companyHeader } = useCompanyHeader({ disableCallApi: true })
  const isBlockCompanyType = [
    COMPANY_TYPES.FUNDS,
    COMPANY_TYPES.INSURANCE,
  ].includes(companyHeader?.companyType)

  return (
    <Element
      style={{ border: type === factSheetTypes.PREVIEW && '1px solid #d5d5d5' }}
    >
      <Header type={type} isBlockCompanyType={isBlockCompanyType} />
      {type === factSheetTypes.PREVIEW && (
        <div style={{ padding: '0 12px' }}>
          <Element style={{ borderTop: '1px solid #d7d7d7' }} />
        </div>
      )}
      {isBlockCompanyType ? (
        <Element style={{ padding: 100, backgroundColor: '#F3F3F3' }}>
          <Notification value="common.order.factSheet.BLOCK_COMPANY_TYPE" />
        </Element>
      ) : (
        <Content type={type} />
      )}
    </Element>
  )
}
